import type { Translations } from '../../../types'

const shopCategoriesMessages: Translations = {
  "shop.categories.validation.nameRequired": "Inserisci il nome categoria",
  "shop.categories.messages.saveError": "Salvataggio categoria fallito",
  "shop.categories.messages.created": "Categoria creata",
  "shop.categories.messages.updated": "Categoria aggiornata",
  "shop.categories.messages.deleted": "Categoria cancellata correttamente",
  "shop.categories.messages.deleteError": "Eliminazione categoria fallita",
}

export default shopCategoriesMessages
